<template>
  <div class="container">
    <div>
      <div class="prompt">
        <h1>404</h1>
        <p>{{ $t('system.404') }}</p>
        <router-link :to="{ path: '/' }">Back to home</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style scoped lang="scss">
.container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: auto;

  & > div {
    display: flex;
  }

  .prompt {
    margin-left: 100px;
    line-height: 1;

    h1 {
      font-size: 80px;
      font-weight: normal;
    }

    p {
      margin-bottom: 30px;
      color: rgba(0, 0, 0, 0.45);
      font-size: 20px;
    }
  }
}
</style>
